export enum STATISTICS_STATUS_ENUM {
  inquired,
  in_approval,
  approved,
  ordered,
  partially_loaded,
  loaded,
  partially_delivered,
  on_delivery,
}
export enum STATISTICS_STATUS_COLOR_ENUM {
  inquired = '#748ffc', // indigo4
  in_approval = '#339af0', // blue5
  approved = '#1098ad', // cyan7
  ordered = '#94d82d', // lime5
  partially_loaded = '#ffec99', // yellow2
  loaded = '#ffd43b', // yellow4
  partially_delivered = '#ffa94d', // orange4
  on_delivery = '#f76707', // orange7
}
